import { Building2, User } from "lucide-react";

export const CLIENT_TYPES = {
  brand: {
    type     : "brand",
    role     : "brand",
    loginType: "admin",
    label    : "Brand",
    desc     : "Campaigns & debit notes",
    icon     : Building2
  },
  publisher: {
    type     : "publisher",
    role     : "publisher",
    loginType: "affiliate",
    label    : "Publisher",
    desc     : "Earnings & payouts",
    icon     : User
  },
  ops: {
    type     : "ops",
    role     : "ops",
    loginType: "ops",
    label    : "Nook Ops",
    desc     : "Internal workspace"
  }
};

export const CLIENT_TYPE_CARDS = [CLIENT_TYPES.brand, CLIENT_TYPES.publisher];
